import { useMemo } from 'react';
import { api } from '@/redux/api';
import { GetUnitFfConnectionsResponse } from '@/types/ff-connection';
import { useCurrentUnit } from './use-current-unit';

export const useUnitFfConnections = () => {
  const { data: unit } = useCurrentUnit();

  const result = api.useGetUnitFfConnectionsQuery({ unitId: unit!.id });
  const data: GetUnitFfConnectionsResponse =
    useMemo(() => result.data, [result.data]) ?? [];
  return { ...result, data };
};
